<template>
  <div>
    <button
      class="btn btn-cf"
      @click="$emit('click')"
    >
      {{ $props.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CinemaButton',
  props: {
    label: {
      type: String,
      default: 'label'
    }
  },
  data () {
    return {}
  },
  methods: {}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
